import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Link } from '@alfa-bank/site-link';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import type { IDepsDesktop, TSearchBlock } from '../models';
import { SearchBarDesktop as SearchBar } from '../components/search-bar/desktop';
import { ResultsDesktop as Results } from '../components/results/desktop';
import { DefaultRequestsDesktop as DefaultRequests } from '../components/default-requests/desktop';
import { SearchForm } from '../components/search-form';

import { SearchBlock as Component } from './search-block';
import styles from './desktop.css';

export const SearchBlockDesktop = createWidget<IDepsDesktop, TSearchBlock>({
    styles,
    Link,
    Text,
    SearchBar,
    Results,
    DefaultRequests,
    SearchForm,
})(Component);
